<template>
  <div class="fertilizer">
    <div class="box">
      <form>
        <table>
          <tbody>
            <tr>
              <td>User name:</td>
              <td align="right">
                <input type="text">
              </td>
            </tr>
            <tr>
              <td>Password:</td>
              <td align="right">
                <input type="password">
              </td>
            </tr>
            <tr>
              <td colspan="2" align="right">
                <input type="submit" value="Sign on, you Crazy Diamond">
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
    <div class="updated">21 IX 2005</div>
  </div>
</template>

<script>
export default {
  name: "signon"
};
</script>

<style scoped>
.fertilizer {
  background-color: #fff;
}

.box {
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  font-size: 1.1em;
  width: 300px;
  margin-top: -80px;
  margin-left: -150px;
  left: 50%;
  color: #000;
}

.box table {
  text-align: left;
  font-size: 1.2em;
  width: 250px;
  margin: 25px;
}

.box table td {
  padding-bottom: 5px;
}

.updated {
  color: #ddd;
}
</style>
